import type { App } from 'vue'
import {
  CHAVE_OPERACOES_CATALOGO_EMPREGADO,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/apresentacao/catalogo-empregado.injecao'
import type {
  OperacoesCatalogoEmpregado,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/catalogo-empregado.tipos'
import {
  criarCasoDeUsoListarOpcoesEmpregado,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/listar-opcoes/listar-opcoes-empregado'
import {
  ListarOpcoesEmpregadoRepositorioHttp,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/listar-opcoes/listar-opcoes-empregado.repositorio-http'

import type { InfraestruturaAplicacao } from '../criar-infraestrutura'

export const comporCatalogoEmpregado = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoEmpregado => {
  const repositorio = new ListarOpcoesEmpregadoRepositorioHttp(
    infraestrutura.httpCondominio,
  )
  return {
    listarOpcoes: criarCasoDeUsoListarOpcoesEmpregado(repositorio.executar),
  }
}

export const instalarEmpregado = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
): void => {
  app.provide(
    CHAVE_OPERACOES_CATALOGO_EMPREGADO,
    comporCatalogoEmpregado(infraestrutura),
  )
}
